export enum EnvironmentType {
  LOCAL = 'Local',
  DEV = 'Dev',
  STAGING = 'Staging',
  LIVE = 'Live',
}
